import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import {
    YAxis,
    XAxis,
    LineChart,
    Line,
    ResponsiveContainer,
    Tooltip,
} from 'recharts';

import { MarketSearchOptions } from '../tabs/marketDashboard';
import MarketTooltip from './marketTooltip';
import { numberWeeks } from './realEstateMarketDateFilters';
import { groupByRollingWeeks } from '../../../utilities/dateHelpers';
import { getDaysBetween } from '../../../utilities/dateHelpers';
import { average } from '../../../utilities/generalHelpers';
import { getYRange } from '../../../utilities/chartHelpers';
import { colors } from '../../../constants';

const AvgDaysOnMarketChart = ({ marketData, searchOptions }) => {
    const chartData = useMemo(() => {
        if (marketData.length) {
            const weeks = numberWeeks[searchOptions[MarketSearchOptions.DateWindow]];
            const grouped = groupByRollingWeeks(
                marketData,
                weeks,
                'mls_history.sold_date',
            );
            const points = grouped.map((group, index) => {
                const weekEnd = DateTime.now().minus({ days: index * 7 });
                const weekStart = weekEnd.minus({ days: 6 });
                const weekLabel = `${weekStart.toFormat('MM/d')} – ${weekEnd.toFormat('MM/d')}`;

                const daysOnMarket = group.items.map((listing) =>
                    getDaysBetween(
                        listing['mls_history.listing_date'],
                        listing['mls_history.sold_date'],
                    ),
                );
                return {
                    week: weekLabel,
                    count: Number(average(daysOnMarket).toFixed(1)),
                };
            });
            points.reverse();
            return points;
        }
        return null;
    }, [marketData]);
    const yRange = useMemo(() => getYRange(chartData, 'count'), [chartData]);

    return (
        <ResponsiveContainer width="100%" height="100%">
            <LineChart
                width="100%"
                height="100%"
                data={chartData}
                margin={{
                    top: 5,
                    right: 20,
                    left: 0,
                    bottom: 5,
                }}
            >
                <XAxis dataKey="week" />
                <YAxis domain={[yRange.min, yRange.max]} />
                <Tooltip
                    content={<MarketTooltip active={false} payload={[]} label="" />}
                />
                <Line
                    type="monotone"
                    dataKey="count"
                    stroke={colors.skyfallDark}
                    dot={false}
                    strokeWidth={2}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default AvgDaysOnMarketChart;
